import { AppStateCreator, DashboardSlice, LeadFilters } from "../types";
import { useAppStore, initialState } from "./index";

export const createDashboardSlice: AppStateCreator<DashboardSlice> = (set) => ({
  dashboard: {
    ...initialState.dashboard,
    leads: {
      ...initialState.dashboard.leads,
      setFilters: (newFilters: Partial<LeadFilters>) => {
        set((state) => {
          state.dashboard.leads.filters = {
            ...state.dashboard.leads.filters,
            ...newFilters,
          };
        });
      },
      resetFilters: () => {
        set((state) => {
          state.dashboard.leads.filters = initialState.dashboard.leads.filters;
          state.dashboard.leads.isFiltering = false;
        });
      },
      applyFilters: (fetch) => {
        set((state) => {
          state.dashboard.leads.isFiltering = true;
        });
        fetch();
      },
      setLoadingFilters: (value) => {
        set((state) => {
          state.dashboard.leads.isFiltering = value;
        });
      },
      setModalStatus: (status) => {
        set((state) => {
          state.dashboard.leads.modalFilter.status = status;
        });
      }
    },
    fleet: {
      ...initialState.dashboard.fleet,
      setOpenModalScoreOperation: () => {
        set((state) => ({
          dashboard: {
            ...state.dashboard,
            fleet: {
              ...state.dashboard.fleet,
              modals: {
                ...state.dashboard.fleet.modals,
                scoreOperation: true,
              },
            },
          },
        }));
      },
      setCloseModalScoreOperation: () => {
        set((state) => ({
          dashboard: {
            ...state.dashboard,
            fleet: {
              ...state.dashboard.fleet,
              modals: {
                ...state.dashboard.fleet.modals,
                scoreOperation: false,
              },
            },
          },
        }));
      },
    },
    maintenances: {
        ...initialState.dashboard.maintenances, 
        setFilters: (newFilters: { startDate: string, endDate: string}) => {
          set((state) => {
            state.dashboard.maintenances.filters.dateFilters = newFilters
          })
        },
        applyFilters: (fetch: () => void) => {
          fetch();
        },
        openModalFilter: () => {
          set((state) => {
            state.dashboard.maintenances.modals.filters = true
          })
        }, 
        closeModalFilter: () => {
          set((state) => {
            state.dashboard.maintenances.modals.filters = false
          })
        },
        resetFilters: () => {
          set((state) => {
            state.dashboard.maintenances.filters.dateFilters = initialState.dashboard.maintenances.filters.dateFilters;
          });
        },
      }
  },
});

export const useDashboardLeads = () => 
  useAppStore((state) => state.dashboard.leads);
export const useDashboardLeadsFilters = () =>
  useAppStore((state) => state.dashboard.leads.filters);
export const useIsDashboardLeadsFiltering = () =>
  useAppStore((state) => state.dashboard.leads.isFiltering);


export const useDashboardMaintenances = () => 
  useAppStore((state) => state.dashboard.maintenances)
